module.exports = __webpack_public_path__ + "img/LUB00058.135c69f5.png";